/**
 * 获取空间显示名称的缩写（取前两个字符）
 */
export const getSpaceInitials = (name?: string): string => {
  if (!name) return 'SP';
  return name.substring(0, 1).toUpperCase();
};

// 基于 spaceId 生成一致的颜色
const colors = [
  '#5B6ACA', // 紫色
  '#E87D7D', // 红色
  '#7DC67D', // 绿色
  '#F0A04B', // 橙色
  '#6ECDE8', // 青色
];

/**
 * 生成空间头像背景色（基于 space_id 生成一致的颜色）
 */
export const getSpaceAvatarColor = (spaceId: string) => {
  const hash = spaceId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return colors[hash % colors.length];
};

/**
 * 获取用户在团队空间中的角色显示文本
 */
export const getRoleDisplayText = (role?: string): string => {
  switch (role) {
    case 'owner':
      return '所有者';
    case 'admin':
      return '管理员';
    case 'member':
      return '成员';
    default:
      return '成员';
  }
};
